<template>
    <dashboard-layout>
        <div class="rounded shadow p-4">
            <div class="d-flex align-items-center justify-content-between"><h5 class="mb-0">Notes:</h5>
<!--                <a-->
<!--                class="btn btn-primary" href="/page-messages"><i>-->
<!--                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"-->
<!--                     stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus fea icon-sm">-->
<!--                    <g>-->
<!--                        <line x1="12" y1="5" x2="12" y2="19"></line>-->
<!--                        <line x1="5" y1="12" x2="19" y2="12"></line>-->
<!--                    </g>-->
<!--                </svg>-->
<!--            </i> Compose</a>-->
            </div>

            <div class=" border-bottom p-3" v-for="note in notes?.data" :key="note.id">
                <a  href="javascript:void(0)" class="text-dark"

                    @click="setQuestion(note.question)">



<!--                        <img src="/static/media/01.6ac85de7298319b1f8d5.jpg"-->
<!--                                                  class="avatar avatar-md-sm rounded-pill shadow" alt="">-->

                            <h6 class="text-dark">{{ note.question?.question }}</h6>

                            <p class="text-muted mb-0" >{{ note.text }}</p>

<!--                            <note-card v-if="note.question"-->
<!--                                       :current-question="{ ...note.question ?? {} , ...{'note' : note ?? {} }}"-->
<!--                                       :title="note.question?.question"></note-card>-->

                </a>
            </div>

            <div class="d-flex align-items-center justify-content-end mt-4">
<!--                <span class="text-muted h6 mb-0">Showing 8 out of 33</span>-->

                <Bootstrap5Pagination
                    class="mb-0"
                    :data="notes"
                    :limit="2"
                    :show-disabled="false"
                    :size="'default'"
                    :align="'center'"
                    @pagination-change-page="getResults"
                />
                <question-modal :question="currentQuestionItem" />

            </div>
        </div>

    </dashboard-layout>
</template>

<script>

import {useToast} from "vue-toastification";
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import DashboardLayout from "../../dashboard-layout.vue";
import NoteCard from "../question_sessions/NoteCard.vue";
import questionModal from "../question_discussion/question-modal.vue";

const toast = useToast();

export default {
    components: {
        questionModal,
        NoteCard,
        DashboardLayout,
        Bootstrap5Pagination
    },
    data() {
        return {
            currentQuestionItem: null,
            notes: [],
            q: this.$route.query,
            form_options: {},
        }
    },
    created() {
        this.getResults();
    },
    methods: {
        getResults(page = this.$route?.query?.page ?? 1) {

            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get('notes', {
                params: {
                    'page': page,
                    'subscribe_id': this.$route?.params?.subscribe_id
                }
            }).then(response => {
                toast.dismiss(id);
                this.notes = response.data;

                this.$router.replace({name: "notes.index", query: {'page': page, 'note': this.q.note}});
            }, response => {
                toast.dismiss(id);
            });

        },
        setQuestion(question){
            console.log(question);
            this.currentQuestionItem = question;

            setTimeout(function () {
                const QModal = new bootstrap.Modal(document.getElementById('questionModal'));
                QModal.show();
            },350);

        }
    }
}
</script>
